import { useQueryClient } from 'react-query';
import { useQueryFetch } from 'sonata-react-components';

import { getDoohReportSettings } from '@/services/doohReport.service';

import type { DoohReportSettingsResponse } from 'sonata-static-storage/lib/entities/doohReport/doohReport.types';

type UseDoohReportSettings = {
  settings: DoohReportSettingsResponse | undefined;
  isLoading: boolean;
  /** Merges a saved change into the cached settings, so every reader of them updates at once. */
  updateSettings: (changes: Partial<DoohReportSettingsResponse>) => void;
};

/**
 * Name and logo the line item's DOOH report is shown with, shared by every part of the report
 * that renders or edits them.
 */
export function useDoohReportSettings(lineItemId: string): UseDoohReportSettings {
  const queryClient = useQueryClient();
  const queryKey = ['doohReport', 'settings', lineItemId];
  const { data: settings, isLoading } = useQueryFetch<DoohReportSettingsResponse>(queryKey, () =>
    getDoohReportSettings(lineItemId)
  );

  const updateSettings = (changes: Partial<DoohReportSettingsResponse>) => {
    queryClient.setQueryData<DoohReportSettingsResponse>(queryKey, current => ({
      logo: null,
      name: null,
      ...current,
      ...changes
    }));
  };

  return { isLoading, settings, updateSettings };
}
